import React from 'react'
import { Helmet } from 'react-helmet'

const Meta = ({ color, title, description, keywords }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name='description' content={description} />
      <meta name='keywords' content={keywords} />
      <style name='background-color'>{`body {background-color: ${color};}`}</style>
    </Helmet>
  )
}

Meta.defaultProps = {
  title: 'Meaah | Pokemon',
  description: 'Welcome to Meaah - Mini Games for Junior Pokemon Fans',
  keywords: 'meaah, pokemon, minigame, mini game, kids',
  color: '#fffaf0',
}

export default Meta
